import { atom } from "recoil";
import { Message } from "../interfaces/Message";

export const currentChatMessagesState = atom({
  key: "currentChatMessages",
  default: [] as Message[],
});
